/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import React from 'react';
import PropTypes from 'prop-types';
import MembersBlockItem from './MembersBlockItem';

const MembersBlock = (props) => {
  const membersItems = [];
  const {
    members,
    showDistance,
    extended,
    type,
    subtype,
    menuType,
  } = props;
  let { topNr } = props;
  let classNames = 'membersBlock ';

  if (extended === true) {
    classNames += 'membersBlock--extended';
  }

  Object.values(members).forEach((item, index) => {
    // Don't show deleted members in favorites
    if (item.status === 'deleted' && type === 'favorites') {
      return;
    }

    // Don't show not ignored in ignored view
    if (!item.ignored && type === 'ignored') {
      return;
    }

    // Don't show not blocked in blocked view
    if (!item.blocked && type === 'blocked') {
      return;
    }

    // Don't show ignored and blocked in regular views
    if ((item.ignored || item.blocked) && type === 'regular') {
      return;
    }

    let customLink = null;
    let key = item._id + index;

    if (topNr != null) {
      topNr += 1;
      key += topNr;
    }

    if (typeof item.custom_link !== 'undefined') {
      customLink = item.custom_link;
    }

    membersItems.push(<MembersBlockItem
      key={key}
      member={item}
      memberId={item._id}
      extended={extended}
      topNr={topNr}
      type={type}
      subtype={subtype}
      customLink={customLink}
      showDistance={showDistance}
      hideMenu={type === 'monitor'}
      menuType={menuType}
    />);
  });

  return (
    <div className={classNames}>
      {membersItems}
    </div>
  );
};

MembersBlock.propTypes = {
  type: PropTypes.string,
  subtype: PropTypes.string,
  topNr: PropTypes.number,
  extended: PropTypes.bool,
  showDistance: PropTypes.bool,
  members: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.instanceOf(Array),
  ]),
  menuType: PropTypes.string,
};

MembersBlock.defaultProps = {
  topNr: null,
  members: {},
  showDistance: false,
  extended: false,
  type: undefined,
  subtype: '',
  menuType: 'user',
};

export default MembersBlock;
